import { AddOnStatus } from 'common/billing/entities/addOns/interfaces'

export const getBillingSentryContext = (state: RootState) => {
  const pro = state.billing?.pro

  if (!pro || !('billing_version' in pro)) {
    return null
  }

  return {
    billing_version: pro.billing_version,
    has_billing_access: state.app?.currentAccountUser?.has_billing_access ?? false,
    products: Object.fromEntries(
      Object.entries(pro.products ?? {}).map(([slug, product]) => [slug, product.active]),
    ),
    add_ons: Object.fromEntries(
      (pro.addons_data ?? []).map((addOn) => [addOn.slug, addOn.status === AddOnStatus.ACTIVE]),
    ),
    is_trial_available: pro.is_trial_available ?? false,
    coupon: pro.coupon_info,
    status: pro.status,
  }
}
